import api from '../api/axios';

// Получить список тикетов пользователя
export const getTickets = async () => {
	const response = await api.get('/support/tickets');
	return response.data;
};

export const getTicket = async (ticketId) => {
	const response = await api.get(`/support/tickets/${ticketId}`);
	return response.data;
};

// Создать новый тикет
export const createTicket = async (data) => {
	const response = await api.post('/support/tickets', data);
	return response.data;
};

// Получить сообщения по тикету
export const getTicketMessages = async (ticketId) => {
	const response = await api.get(`/support/tickets/${ticketId}/messages`);
	return response.data;
};

// Отправить сообщение в тикет
export const sendTicketMessage = async (ticketId, message) => {
	const response = await api.post(`/support/tickets/${ticketId}/messages`, { message });
	return response.data;
};

// Закрыть тикет
export const closeTicket = async (ticketId) => {
	const response = await api.post(`/support/tickets/${ticketId}/close`);
	return response.data;
}; 